import cookie from 'js-cookie';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { WithStyles, withStyles } from '@mui/styles';
import { bindActionCreators, Dispatch } from 'redux';

// Contexts
import { withTenant, withTranslate } from '../../../core/TenantProvider';
// Components - Atoms, Molecules, Organisms, Pages
import APHeading from '../../atoms/APHeading';
import APSelectDropdown from '../../atoms/APSelectDropdown';
// Files in the same folder
import APAccountSwitchSectionStyles from './styles/APAccountSwitchSection.style';
// Redux
import { ReducerState } from '../../../redux/modules';
import { actions as UserActions } from '../../../redux/modules/user';
// Utils
import { convertIntoAccountSwitchOptions } from '../../../core/utils/ConvertIntoAccountSwitchOptions/ConvertIntoAccountSwitchOptions';
// Constants
import { CD_ZA_LEGAL_ENTITY, LEGAL_ENTITY_CDH_COMPANY_MAPPING, SSO_CDH_COMPANY_KEY } from '../../../core/utils/Constants/Constants';

interface APAccountSwitchSectionProps extends WithStyles<typeof APAccountSwitchSectionStyles> {
    translate: any;
    affiliateDetails: any;
    updateTenant: Function;
    getAffiliateDetails: Function
}

interface DropDownOption {
    label: string;
    icon: string;
    affiliateNumber: string;
    legalEntity: string;
    value: string;
}
const APAccountSwitchSection = (props: APAccountSwitchSectionProps) => {
    const { classes, translate, affiliateDetails } = props;

    const [selectedAccount, setSelectedAccount] = useState<string>(
        affiliateDetails?.affiliate?.SF_ID ?? ''
    );

    useEffect(() => {
        if (affiliateDetails) {
            setSelectedAccount(affiliateDetails?.affiliate?.SF_ID);
        }
    }, [affiliateDetails]);


    const getDropdownOptionList: () => DropDownOption[] = useCallback(() => {
        const { company_name, legal_entity, affiliate_Number, SF_ID } = affiliateDetails?.affiliate || {};

        return [
            {
                label: company_name ?? '',
                icon: legal_entity === CD_ZA_LEGAL_ENTITY ? 'countries/south-africa' : 'countries/united-kingdom',
                affiliateNumber: affiliate_Number ?? '',
                legalEntity: legal_entity,
                value: SF_ID ?? ''
            },
            ...convertIntoAccountSwitchOptions(affiliateDetails?.affiliateRelatedRecords)
        ];
    }, [affiliateDetails]);

    const onAccountChange = useCallback((event: { target: { value: any; }; }) => {
        const selectedValue = event.target.value;
        const selectedRelatedRecord: any = getDropdownOptionList().find(
            (option) => option.value === selectedValue
        );

        const referringCdhCompany = LEGAL_ENTITY_CDH_COMPANY_MAPPING[selectedRelatedRecord?.legalEntity];

        sessionStorage.setItem('affiliate-id', selectedRelatedRecord.value);

        cookie.set(SSO_CDH_COMPANY_KEY, referringCdhCompany, {
            path: '/'
        });

        sessionStorage.setItem('affiliate-number', selectedRelatedRecord.affiliateNumber);
        cookie.set('affiliate-number', selectedRelatedRecord.affiliateNumber, {
            path: '/'
        });

        setSelectedAccount(selectedValue);
        setTimeout(() => {
            window.location.reload();
        }, 300);
    }, [getDropdownOptionList]);

    const fullName = useMemo(() => {
        const { user_first_name, user_last_name } = affiliateDetails?.affiliate || {};
        return `${user_first_name || ''} ${user_last_name || ''}`.trim();
    }, [affiliateDetails]);

    return (
        <div className={classes.container}>
            <div className={classes.leftSection}>
                <div className={classes.upperText}>{translate('account.section.accountswitch.text')}</div>
                <APHeading className={classes.lowerText} variant="h4">
                    {fullName}
                </APHeading>
            </div>
            <div className={classes.rightSection}>
                <APSelectDropdown
                    name={'accountSwitchType'}
                    value={selectedAccount}
                    data={getDropdownOptionList()}
                    onChange={onAccountChange}
                    shouldDisableScrollLock={false}
                />
            </div>
        </div>
    )
};

const mapStateToProps = (state: ReducerState) => ({
    affiliateDetails: state.user.affiliateDetails
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    getAffiliateDetails: UserActions.getAffiliateDetails,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
    withTenant(withTranslate(withStyles(APAccountSwitchSectionStyles)(APAccountSwitchSection)))
);